import LinkWithArrow from "./LinkWithArrow";

export default LinkWithArrow;
